<template>
  <v-card>
    <v-toolbar text dense height="45">
      <v-btn icon class="success" @click.prevent="chooseFiles" :alt="`Upload to ${filePath}`">
        <v-icon>cloud_upload</v-icon>
      </v-btn>
      <input
        type="file"
        ref="fileInput"
        accept="image/jpeg, image/png"
        v-show="false"
        @change="detectFiles($event.target.files)"
      />
      <div v-if="uploadSuccess">
        Uploaded file
        <strong>{{uploadSuccess}}</strong>
      </div>
      <div v-else-if="uploadError">
        <v-icon error>warning</v-icon>
        {{uploadError}}
      </div>
      <div v-else-if="progressUpload === 0">Select a file to upload to {{ filePath }}</div>
      <v-progress-linear v-model="progressUpload" color="teal" v-if="progressUpload > 0"></v-progress-linear>
      <v-btn icon left text @click.prevent="clearUpload" :alt="`Upload to ${filePath}`">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-toolbar>
  </v-card>
</template>

<script>
import fb from "@/firebase";

export default {
  name: "FileUpload",
  props: {
    filePath: String,
    fileName: String
  },
  data() {
    return {
      loading: false,
      progressUpload: 0,
      uploadTask: "",
      uploadError: "",
      uploadSuccess: "",
      alert: true
    };
  },
  computed: {
    uploadedFileUrl: {
      get() {
        return this.value;
      },
      set(url) {
        this.$refs.fileInput.value = "";
        this.$emit("input", url);
        this.progressUpload = 0;
        console.log("url set", url);
      }
    }
  },
  methods: {
    clearUpload() {
      this.uploadSuccess = "";
      this.uploadError = "";
      this.uploadedFileUrl = null;
    },
    chooseFiles() {
      this.uploadSuccess = this.uploadError = "";
      this.$refs.fileInput.click();
    },
    detectFiles(fileList) {
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x]);
      });
    },
    upload(file) {
      //console.log(file);
      if (file.size > 1 * 1024 * 1024) {
        this.uploadError =
          "Filesize exceeds of 1 MB, please reduce image size.";
        this.$refs.fileInput.value = "";
        return;
      }
      let fileNameArray = file.name.split(".");
      const fileExt = fileNameArray.pop().toLowerCase();
      // public_images by default
      const fileNewName = this.fileName || fileNameArray.join("");
      // Only slugify if the filename is not set
      const slugFileName = this.fileNAme
        ? this.slugify(fileNewName)
        : fileNewName;
      const fileFinalName = [slugFileName, fileExt].join(".");
      const filePath = [this.filePath || "public_images", fileFinalName].join(
        "/"
      );
      //console.log("fileFinalName", fileFinalName);
      this.uploadTask = fb.storage.child(filePath).put(file);
    },
    slugify(text, separator) {
      text = text
        .toString()
        .toLowerCase()
        .trim();

      const sets = [
        { to: "a", from: "[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]" },
        { to: "c", from: "[ÇĆĈČ]" },
        { to: "d", from: "[ÐĎĐÞ]" },
        { to: "e", from: "[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]" },
        { to: "g", from: "[ĜĞĢǴ]" },
        { to: "h", from: "[ĤḦ]" },
        { to: "i", from: "[ÌÍÎÏĨĪĮİỈỊ]" },
        { to: "j", from: "[Ĵ]" },
        { to: "ij", from: "[Ĳ]" },
        { to: "k", from: "[Ķ]" },
        { to: "l", from: "[ĹĻĽŁ]" },
        { to: "m", from: "[Ḿ]" },
        { to: "n", from: "[ÑŃŅŇ]" },
        { to: "o", from: "[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]" },
        { to: "oe", from: "[Œ]" },
        { to: "p", from: "[ṕ]" },
        { to: "r", from: "[ŔŖŘ]" },
        { to: "s", from: "[ßŚŜŞŠ]" },
        { to: "t", from: "[ŢŤ]" },
        { to: "u", from: "[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]" },
        { to: "w", from: "[ẂŴẀẄ]" },
        { to: "x", from: "[ẍ]" },
        { to: "y", from: "[ÝŶŸỲỴỶỸ]" },
        { to: "z", from: "[ŹŻŽ]" },
        { to: "-", from: "[·/_,:;']" }
      ];

      sets.forEach(set => {
        text = text.replace(new RegExp(set.from, "gi"), set.to);
      });

      text = text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text

      if (typeof separator !== "undefined" && separator !== "-") {
        text = text.replace(/-/g, separator);
      }

      return text;
    }
  },
  mounted: function() {},
  watch: {
    uploadTask: function() {
      this.uploadError = "";
      this.uploadTask.on(
        "state_changed",
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          );
        },
        error => {
          this.uploadError = error.message_;
          this.$refs.fileInput.value = "";
        },
        () => {
          console.log(
            "this.uploadTask.snapshot.ref",
            this.uploadTask.snapshot.ref
          );
          const reference = this.uploadTask.snapshot.ref;
          reference.getDownloadURL().then(downloadURL => {
            this.uploadSuccess = reference.name;
            this.uploadError = "";
            this.uploadedFileUrl = {
              public_url: downloadURL,
              name: reference.name,
              bucket: reference.bucket,
              path: reference.fullPath
            };
          });
        }
      );
    }
  }
};
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
</style>
